module.exports = __webpack_public_path__ + "img/专科1.9a44d628.jpg";